<template>
    <div>
        <img v-src="'https://oss.cloud.custouch.com/res/29827/地图.png'" width="100%">
        <List-View :list='list'
        row-key="title"
                   @click-button="go">
        </List-View>
    </div>
</template>
<script>
import ListView from './compoennts/ListView'
import fetchData from '@/service/fetchData'

export default {
    components: {
        ListView
    },
    data() {
        return {
            list: []
        }
    },
    methods: {
        async init() {
            this.list = await fetchData(window.env.VUE_APP_VC_OFFLINE_ACTIVITY)
        },
        go({ link }) {
            link && (window.location.href = link)
        }
    },
    created() {
        this.init()
    }
}
</script>